<template>
    <div id="app">
        <app-header></app-header>
        <router-view></router-view>
    </div>
</template>

<script>
  import Header from '@/components/header/Header.vue'

  export default {
    name: 'app',
    data () {
      return {
        isAuth: false,
        username: ''
      }
    },
    components: {
      'app-header': Header
    }
  }
</script>

<style lang="scss" type="text/scss">
    @import '/assets/scss/main.scss';

    body {
      font-family: 'Open Sans', sans-serif;
    }
    
</style>



// WEBPACK FOOTER //
// App.vue?7d49370e